import type {
  ConfirmEmailRequest,
  LoginRequest,
  ResendOtpRequest,
  ResetPasswordFinishRequest,
  ResetPasswordInitRequest,
  SetupPasswordRequest,
  SupplierSignupRequest,
} from "~/Core/Models/index";

import axios from "./config";

const SCHEMA = "/auth/supplier";

export function LogIn(data: LoginRequest) {
  return axios.post(`${SCHEMA}/login`, data);
}

export function ResendOtp(data: ResendOtpRequest) {
  return axios.post(`/auth/otp/resend`, data);
}

export function SignUp(data: SupplierSignupRequest) {
  return axios.post(`${SCHEMA}/signup`, data);
}

export function confirmEmail(data: ConfirmEmailRequest) {
  return axios.post(`${SCHEMA}/confirm-email`, data);
}

export function SetupPassword(data: SetupPasswordRequest) {
  return axios.post(`/supplier/user/setup-password`, data);
}

export function InitPassword(data: ResetPasswordInitRequest) {
  return axios.post(`/supplier/user/init-password`, data);
}

export function ForgetPassword(data: ResetPasswordInitRequest) {
  return axios.post(`/auth/reset-password/init`, data);
}

export function ForgetPasswordFinish(data: ResetPasswordFinishRequest) {
  return axios.post(`/auth/reset-password/finish`, data);
}
